import NextLink, { LinkProps } from 'next/link';
import { ReactNode, AnchorHTMLAttributes } from 'react';

type SafeLinkProps = Omit<LinkProps, 'onClick'> & {
  children: ReactNode;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
} & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'onClick'>; 
export default function SafeLink({ href, children, ...props }: SafeLinkProps) {
  if (!href) {
    console.warn('⚠️ SafeLink получил undefined href', props);
    return <span {...props}>{children}</span>;
  }

  return (
    <NextLink href={href} {...props}>
      {children}
    </NextLink>
  );
}
